module.exports = __webpack_public_path__ + "static/media/FMX-GFX-750-1060-1260.405154cc.png";